import React, { useContext, useState, useEffect } from 'react';
import Loader from '../loading/Loader';
import {
  PortfolioDiv,
  PortfolioLightBox,
  PortfolioSection,
} from './portfolioStyle';
import Projects from '../projects/Projects';
import AgbaContext from '../../context/agba/agbaContext';

const Portfolio = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar, projects, getProjects } = agbaContext;

  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    getProjects();
    if (!spinner) {
      setSpinner(false);
    }
    // eslint-disable-next-line;
  }, [spinner]);

  const [state, setState] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);

  const lightBox = (project_img) => {
    if (state) {
      setState(false);
      setPreviewImg(null);
    } else {
      setState(true);
      setPreviewImg(project_img);
    }
  };
  const handleClose = () => {
    setState(false);
  };
  const loadTime = (loader) => {
    setSpinner(loader);
  };

  return (
    <PortfolioDiv>
      {spinner ? (
        <Loader loadTime={loadTime} />
      ) : (
        <>
          {state && (
            <PortfolioLightBox>
              <span className='close' onClick={handleClose}>
                &times;
              </span>
              <div className='navigation'>
                <img src={previewImg} alt='' className='modal-content' />
              </div>
            </PortfolioLightBox>
          )}
          <PortfolioSection sideBar={sideBar}>
            <div className='project-div'>
              {projects !== null
                ? projects.map((item, index) => (
                    <Projects
                      layoutIndex={index + 1}
                      projectData={item.fields}
                      key={item.id}
                      lightBox={lightBox}
                    />
                  ))
                : 'Loading...'}
            </div>
          </PortfolioSection>
        </>
      )}
    </PortfolioDiv>
  );
};

export default Portfolio;
